import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function QuickBooksCallback() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const code = searchParams.get('code');
    const realmId = searchParams.get('realmId');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      // Send error to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'quickbooks_callback',
          error: error
        }, window.location.origin);
      }
      return;
    }

    if (code && realmId) {
      setStatus('success');
      // Send data to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'quickbooks_callback',
          code,
          realmId,
          state
        }, window.location.origin);
        
        // Close this window after a short delay
        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        // If no opener, redirect to settings page
        setTimeout(() => {
          window.location.href = '/settings/quickbooks';
        }, 2000);
      }
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {status === 'processing' && (
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
              <h2 className="mt-4 text-lg font-medium text-gray-900">Processing Authorization...</h2>
              <p className="mt-2 text-sm text-gray-500">Please wait while we complete the QuickBooks connection.</p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="mt-4 text-lg font-medium text-gray-900">Authorization Successful!</h2>
              <p className="mt-2 text-sm text-gray-500">QuickBooks has been connected. This window will close automatically.</p>
            </div>
          )}

          {status === 'error' && (
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="mt-4 text-lg font-medium text-gray-900">Authorization Failed</h2>
              <p className="mt-2 text-sm text-gray-500">
                There was a problem connecting to QuickBooks. Please close this window and try again.
              </p>
              <button
                onClick={() => window.close()}
                className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-600 hover:bg-gray-700"
              >
                Close Window
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuickBooksCallback;

